import React, { useState } from "react";
import { observer } from "mobx-react";

import { Bet } from "@models";
import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";
import BetItemDetailsToggle from "./BetItemDetailsToggle";
import BetItemTable from "./BetItemTable";
import BetItemCardHeader from "./BetItemCardHeader";
import BetCombinations from "@features/my-bets/shared/BetCombinations";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import BetItemTabCardHeader from "./BetItemTabCardHeader";

export default observer(function BetItem({
	bet,
	isMyBetsTab = false,
}: {
	bet: Bet;
	isMyBetsTab?: boolean;
}) {
	const [showCombinations, setShowCombinations] = useState(false);

	const [isDetailsDisplayed, setDetailsDisplayed] = useState(false);
	const toggleDetails = () => setDetailsDisplayed(!isDetailsDisplayed);

	if (bet.isRemoved) {
		return null;
	}

	return (
		<ErrorBoundaryWithPropagation componentName={"Desktop/BetItem.tsx"}>
			<MyBetsBetContext.Provider value={bet}>
				<div id={`bet-item-${bet.id}`} className="card--bet">
					<div className="logo"></div>
					{isMyBetsTab ? (
						<BetItemTabCardHeader />
					) : (
						<BetItemCardHeader />
					)}

					<BetItemTable
						toggleDetails={toggleDetails}
						isDetailsDisplayed={isDetailsDisplayed}
						setShowCombinations={setShowCombinations}
					/>
					<BetCombinations
						setShowCombinations={setShowCombinations}
						showCombinations={showCombinations}
					/>
					<div className="table--bets__footer">
						<BetItemDetailsToggle
							toggleDetails={toggleDetails}
							isDetailsDisplayed={isDetailsDisplayed}
						/>
					</div>
				</div>
			</MyBetsBetContext.Provider>
		</ErrorBoundaryWithPropagation>
	);
});
